import { render, staticRenderFns } from "./ConfigPaymentAddEditDialog.vue?vue&type=template&id=73c821d5"
import script from "./ConfigPaymentAddEditDialog.vue?vue&type=script&lang=js"
export * from "./ConfigPaymentAddEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports